'use client';
import dynamic from 'next/dynamic';

const Content = dynamic(() => import('./Content').then((mod) => mod.Content), {
	ssr: false,
});

import { Modal } from '~components/Modals/Base';
import { IdHideEmailConfirmModal } from '~features/emailConfirm';

import type { SubscriptionModalProps } from '../../model/types';

export const SubscriptionModal = ({
	open,
	locked,
	onClose,
	...props
}: SubscriptionModalProps) => {
	return (
		<Modal className="fullpage" open={open} locked={locked} onClose={onClose}>
			<div id={IdHideEmailConfirmModal} style={{ display: 'none' }} />
			<Content open={open} onClose={onClose} locked={locked} {...props} />
		</Modal>
	);
};
